class SecureFileUploaderStepIndicatorController {
  constructor() {
    this.name = 'secureFileUploaderStepIndicator';
  }

  hasProgressed() {
    return this.stepProgress > 0 && !this.stepError;
  }

  hasError() {
    return this.stepError;
  }

  isComplete() {
    return this.stepProgress >= 100;
  }

  progressClass() {
    if(this.hasError()){
      return 'secureFileUploaderStepIndicator__hasError_stepNumber';
    }
    return `progress-${this.stepProgress}`;
  }
}

export default SecureFileUploaderStepIndicatorController;



// WEBPACK FOOTER //
// ./app/components/secureFileUploaderStepIndicator/secureFileUploaderStepIndicator.controller.js